import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LanguageService } from '@core/i18n/language.service';

export const acceptLanguageInterceptor: HttpInterceptorFn = (req, next) => {
  const languageService = inject(LanguageService);

  return next(
    req.clone({
      setHeaders: {
        'Accept-Language': languageService.getAcceptLanguageHeader(),
      },
    })
  );
};
